export default __webpack_public_path__ + "static/media/50-min.e0cc8fde.png";